import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Observable, fromEvent, Subject, takeUntil, debounceTime } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { InstallationService } from 'src/app/services/installation.service';
import {
  DtInstallationPeriod,
  getInstallationCategoryTranslation,
  InstallationCategory,
  InstallationCategoryOptions,
  InstallationTableData,
  OtpAction,
  SortByOptions,
} from 'src/app/models/installation.model';
import { DtMeterInstallationInvoiceDto } from 'src/app/models/dt-meter-installation-invoice.model';
import { KeyValueItem } from 'src/app/models/keyValueItem.model';
import { TranslationService } from 'src/app/services/translation.service';
import { PermissionsEnum } from 'src/app/models/role.model';
import { TariffService } from 'src/app/services/tariff.service';
import { AreaService } from 'src/app/services/area.service';
import { RegionService } from 'src/app/services/region.service';
import { Region } from 'src/app/models/region.model';
import { Area } from 'src/app/models/area.model';
import { Tariff } from 'src/app/models/tariff.model';
import { ChecklistItem } from 'src/app/models/checklist-item.model';
import { MeterStatus } from 'src/app/models/meter.model';
import { CustomerType, TypeOfConnection } from 'src/app/models/customer.model';
import { SurveyInstallationReopenStatus } from 'src/app/models/survey.model';
import { AuthService, GeographicalRegion, GeographicalRegionService, PermissionsService, SubGeographicalRegion, SubGeographicalRegionService } from 'shared-lib';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { OrganizationTeamApiService } from 'src/app/services/organization-team-api.service';
import { MeterInventoryType } from 'src/app/enums/meter-inventory-type.enum';
import { InstallationsInvoiceListBase } from './installations-invoice-list.base';

declare var bootstrap: any;

export enum ApproveMode {
  Meter = 'Meter',
  Invoice = 'Invoice',
}

enum MeterTypeTab {
  CustomerMeter = 'CustomerMeter',
  DtMeter = 'DtMeter',
}

@Component({
  selector: 'app-installations-list',
  templateUrl: './installations-list.component.html',
  styleUrls: ['./installations-list.component.scss'],
})
export class InstallationsListComponent extends InstallationsInvoiceListBase implements OnInit {
  public PermissionsEnum = PermissionsEnum;
  public MeterTypeTab = MeterTypeTab;
  selectedMeterTab: MeterTypeTab = MeterTypeTab.CustomerMeter;
  ApproveMode = ApproveMode;
  @ViewChild('closeAcknowledgeModal') closeAcknowledgeModal: ElementRef;
  acknowledgeInvoiceId: number = 0;
  @Input() dateFrom: string;
  @Input() dateTo: string;
  mapSortBy: Record<number, string> = {
    [SortByOptions.NEWEST]: 'COMMON.SORT_BY.NEWEST',
    [SortByOptions.OLDEST]: 'COMMON.SORT_BY.OLDEST',
  };
  sortByValue: SortByOptions = SortByOptions.NEWEST;
  sortByOptions = SortByOptions;
  sortByName: string = this.mapSortBy[SortByOptions.NEWEST];
  showSortBy: boolean = false;

  //tab counts
  countAssigned: number = 0;
  countRejected: number = 0;
  countApproved: number = 0;
  countSubmited: number = 0;
  countResubmitted: number = 0;
  countAwaitingApproval: number = 0;
  showUpload: boolean = false;
  showDownload: boolean = false;
  count: number = 2;
  utilityId: number = 0;

  pageSize: number = 10;
  currentPage: number = 1;
  currentTab: number = 4;
  searchText: string = '';
  searchTextUpdate = new Subject<string>();
  currentTabName: string = 'Assigned';
customerSearchByOptions = [
    {
      name: 'AccountNumber',
      value: 'Account No.',
      translation: 'CUSTOMERS.SEARCH_BY.ACCOUNT_NO',
    },
    { name: 'Address', value: 'Address', translation: 'COMMON.ADDRESS' },
    {
      name: 'MeterNumber',
      value: 'Meter No.',
      translation: 'CUSTOMERS.SEARCH_BY.METER_NO',
    },
    {
      name: 'ContractNumber',
      value: 'Contract Number',
      translation: 'COMMON.CONTRACT_NUMBER',
    },
    {
      name: 'MapId',
      value: 'Map Id',
      translation: 'SURVEYS.MAP_ID',
    }
  ];
dtSearchByOptions = [
    {
      name: 'DtName',
      value: 'Name',
      translation: 'INSTALLATIONS.NAME',
    },
    {
      name: 'MeterNumber',
      value: 'Meter No.',
      translation: 'CUSTOMERS.SEARCH_BY.METER_NO',
    },
  ];
  get searchByOptions() {
    return this.selectedMeterTab === MeterTypeTab.DtMeter ? this.dtSearchByOptions : this.customerSearchByOptions;
  }
  selectedSearchTypeDisplay: string;
  showSelectSearchType: boolean = false;
  selectedSearchType: string;
  searchFilterApplied: boolean = false;
  installations: InstallationTableData[] = [];
  stats: KeyValueItem[] = [];
  public detailsShowed: boolean = false;

  clickObservable: Observable<Event> = fromEvent(document, 'click');
  private ngUnsubscribe = new Subject<void>();

  customerType: number = 0;
  customerTypeOptions = [
    { name: 'Prepaid', value: CustomerType.Prepaid, translation: 'COMMON.CUSTOMER_TYPE_OPTIONS.PREPAID' },
    { name: 'Postpaid', value: CustomerType.Postpaid, translation: 'COMMON.CUSTOMER_TYPE_OPTIONS.POSTPAID' },
  ];
  customerPhase: number = -1;
  customerPhaseOptions = [
    { name: 'Single Phase', value: TypeOfConnection.SinglePhase, translation: 'COMMON.CUSTOMER.PHASE_OPTIONS.SINGLE' },
    { name: 'Three Phase', value: TypeOfConnection.ThreePhase, translation: 'COMMON.CUSTOMER.PHASE_OPTIONS.THREE' },
  ];
  meterStatus: number = 0;
  meterStatusOptions = [
    { name: 'Unmetered', value: MeterStatus.Unmetered, translation: 'CUSTOMER_DETAILS.UNMETERED' },
    { name: 'Metered', value: MeterStatus.Metered, translation: 'CUSTOMER_DETAILS.METERED' },
  ];
  dtType: number = 0;
  dtTypeOptions = [
    { name: 'Private', value: 1, translation: 'COMMON.PRIVATE' },
    { name: 'Public', value: 2, translation: 'COMMON.PUBLIC' },
    { name: 'MDAs', value: 3, translation: 'COMMON.MDA' },
    { name: 'Utility', value: 4, translation: 'COMMON.UTILITY' },
  ];
  dtMeterStatus: number = 0;
  installationCategory: number = 0;
  installationCategoryOptions = InstallationCategoryOptions;
  submissionStatus: number = 0;
  submissionStatusOptions = [
    { name: 'Submitted', value: 1, translation: 'COMMON.ASSET_STATUS.SUBMITTED' },
    { name: 'Resubmitted', value: 7, translation: 'COMMON.ASSET_STATUS.RESUBMITTED' },
  ];
  reopenStatus: number = 0;
  reopenStatusOptions = [
    { name: 'Initial', value: SurveyInstallationReopenStatus.Initial, translation: 'SURVEYS.REOPEN_STATUS.INITIAL' },
    { name: 'Reopen', value: SurveyInstallationReopenStatus.Reopen, translation: 'SURVEYS.REOPEN_STATUS.REOPEN' },
  ];

  showFilterBy: boolean = false;
  regions: Region[] = [];
  areas: Area[] = [];
  allAreas: Area[] = [];
  geographicalRegions: (GeographicalRegion & { checked?: boolean })[] = [];
  allSubGeographicalRegions: (SubGeographicalRegion & { checked?: boolean })[] = [];
  subGeographicalRegions: (SubGeographicalRegion & { checked?: boolean })[] = [];
  selectedSubGeographicalRegions: number[] = [];
  clicked: boolean = false;
  tariff: number = 0;
  tariffs: Tariff[] = [];
  selectedAreas: number[] = [];
  selectedRegions: number[] = [];
  selectedFilters: ChecklistItem[] = [];
  reset: boolean = false;
  selectedOrganizationId: number = 0;

  periodMonths: number[] = [];
  periodYear: number = 0;

  @ViewChildren('otpInput0, otpInput1, otpInput2, otpInput3') otpInputs: QueryList<ElementRef>;
  otpMaskedEmail: string = '';
  otpDigits: string[] = ['', '', '', ''];
  otpError: string = '';
  otpExpired: boolean = false;
  otpResendSeconds: number = 0;
  otpRequestInProgress: boolean = false;
  approveInvoiceId: number = 0;
  private otpResendTimer: any;
  private otpModalInstance: any;

  constructor(
    toastr: ToastrService,
    public permissionsService: PermissionsService,
    translationService: TranslationService,
    installationService: InstallationService,
    regionService: RegionService,
    areaService: AreaService,
    private analyticsService: AnalyticsService,
    private tariffService: TariffService,
    private organizationService: OrganizationTeamApiService,
    private authService: AuthService,
    geographicalRegionService: GeographicalRegionService,
    subGeographicalRegionService: SubGeographicalRegionService, ) {
       super(toastr, installationService, regionService, areaService, geographicalRegionService, subGeographicalRegionService, translationService);
       this.hasCimDataIntegration = this.authService.hasCimDataIntegration;
    }

  ngOnInit(): void {
    this.utilityId = parseInt(localStorage.getItem('utilityId') || '');
    const customerAllowed = this.permissionsService.hasDashboardConfigInstallation && this.permissionsService.isInstallationViewAllowed;
    const dtAllowed = this.permissionsService.hasDashboardConfigDtMeterInstallation && this.permissionsService.isDtMeterInstallationViewAllowed;
    const storedTab = localStorage.getItem('installationsMeterTab');
    if (storedTab === MeterTypeTab.DtMeter && dtAllowed) {
      this.selectedMeterTab = MeterTypeTab.DtMeter;
    } else if (customerAllowed) {
      this.selectedMeterTab = MeterTypeTab.CustomerMeter;
    } else if (dtAllowed) {
      this.selectedMeterTab = MeterTypeTab.DtMeter;
    }
    this.setFilters();
    this.getInstallationStats();
    let invoiceRestored = false;
    if (this.selectedMeterTab === MeterTypeTab.DtMeter) {
      this.loadInvoiceStats();
      invoiceRestored = this.restoreInvoiceFilter();
    }
    if (this.hasCimDataIntegration) {
      this.getGeographicalRegions();
      this.getSubGeographicalRegions();
    } else {
      this.getRegions();
      this.getAreas();
    }
    this.getTariffs();
    this.getOrganizations();
    if (!invoiceRestored) this.getData();
    this.searchTextUpdate.pipe(debounceTime(500)).subscribe((_) => {
      if (this.searchText == '') this.search();
      this.searchFilterApplied = false;
    });
     this.selectedSearchType =
      this.selectedSearchType ?? this.searchByOptions[0].name;
        this.selectedSearchTypeDisplay =
      this.selectedSearchTypeDisplay ?? this.searchByOptions[0].translation;
  }

  ngOnDestroy(): void {
    this.searchTextUpdate.complete();
    this.stopOtpResendTimer();
    this.invoiceSearchTextUpdate.complete();
  }

  getFilterObject() {
    let obj = {
      status: this.currentTab,
      dateFrom: this.dateFrom ? this.dateFrom : null,
      dateTo: this.dateTo ? `${this.dateTo}T23:59:59` : null,
      sortBy: this.sortByValue,
      search: this.searchText,
      selectedAreas: this.selectedAreas,
      selectedRegions: this.selectedRegions,
      selectedGeographicalRegions: this.geographicalRegions.filter((x) => x.checked).map((x) => x.id),
      selectedSubgeographicalRegions: this.selectedSubGeographicalRegions,
      customerType: this.customerType,
      customerPhase: this.customerPhase,
      meterStatus: this.meterStatus,
      tariffId: this.tariff,
      searchType: this.selectedSearchType,
      organizationId: this.selectedOrganizationId,
      submissionStatus: this.submissionStatus,
      meterInventoryType: this.selectedMeterTab === MeterTypeTab.DtMeter ? MeterInventoryType.Asset : MeterInventoryType.Customer,
      dtType: this.dtType,
      installationCategory: this.installationCategory,
      dtMeterStatus: this.dtMeterStatus,
      periodMonths: this.periodMonths,
      periodYear: this.periodYear,
      reopenStatus: this.reopenStatus == 0 ? null : this.reopenStatus,
    };
    return obj;
  }
  download(isDeclinedReport: boolean = false) {
    let obj = { ...this.getFilterObject(), isDeclinedReport };
    this.installationService.download(obj).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success('File downloaded');
          window.location.href = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }

  onFilterBy(option: any) {
    if (option === 'New Installations')
      this.changeTab(1);
    else if (option === 'Approved Installations')
      this.changeTab(2);
    else if (option === 'Rejected Installations')
      this.changeTab(3);
  }

  setMeterTab(tab: MeterTypeTab) {
    this.selectedMeterTab = tab;
    this.clearInvoiceTab();
    localStorage.setItem('installationsMeterTab', tab);
    this.currentTab = 4;
    this.currentTabName = 'Assigned';
    this.sortByValue = SortByOptions.NEWEST;
    this.sortByName = this.mapSortBy[SortByOptions.NEWEST];
    this.pageSize = 10;
    this.currentPage = 1;
    this.dateFrom = '';
    this.dateTo = '';
    this.dtType = 0;
    this.dtMeterStatus = 0;
    this.installationCategory = 0;
    this.showUpload = false;
    this.selectedAreas = [];
    this.selectedRegions = [];
    this.selectedSearchType = this.searchByOptions[0].name;
    this.selectedSearchTypeDisplay = this.searchByOptions[0].translation;
    this.periodMonths = [];
    this.periodYear = 0;
    this.resetFilter(1, false);
    this.filterByMeterTab();
  }

  private filterByMeterTab() {
    this.getInstallationStats();
    if (this.selectedMeterTab === MeterTypeTab.DtMeter) this.loadInvoiceStats();
    this.reloadTable(1);
  }

  approveMode: ApproveMode = ApproveMode.Meter;
  approvePeriods: DtInstallationPeriod[] = [];
  approveVendors: { id: number; name: string }[] = [];
  approvePeriodOptions: DtInstallationPeriod[] = [];
  selectedApproveVendorId?: number;
  selectedApprovePeriod?: DtInstallationPeriod;

  openApproveModal(mode: ApproveMode) {
    this.approveMode = mode;
    this.approveInvoiceId = 0;
    this.selectedApproveVendorId = undefined;
    this.selectedApprovePeriod = undefined;
    this.approvePeriodOptions = [];
    this.getDtInstallationPeriods();
  }

  onApproveVendorChange() {
    this.selectedApprovePeriod = undefined;
    this.approvePeriodOptions = this.selectedApproveVendorId
      ? this.approvePeriods.filter((x) => x.vendorId === this.selectedApproveVendorId)
      : [];
  }

  getApprovePeriodLabel(period: DtInstallationPeriod): string {
    return new Date(period.year, period.month - 1, 1)
      .toLocaleString('en-US', { month: 'long', year: 'numeric' });
  }

  confirmApprove() {
    if (!this.selectedApproveVendorId || !this.selectedApprovePeriod) {
      this.toastr.warning('Please select a vendor and a period.');
      return;
    }
    this.requestApprovalOtp(true);
  }

  openApproveInvoiceModal(invoice: DtMeterInstallationInvoiceDto) {
    this.approveInvoiceId = invoice.id;
  }

  confirmApproveInvoice() {
    this.requestInvoiceApprovalOtp(true);
  }

  resendOtp() {
    if (this.otpResendSeconds > 0 && !this.otpExpired) return;
    if (this.approveInvoiceId) this.requestInvoiceApprovalOtp(false);
    else this.requestApprovalOtp(false);
  }

  onOtpDigitInput(event: any, index: number) {
    const value = event.target.value;
    if (value && !/^\d$/.test(value)) {
      this.otpDigits[index] = '';
      return;
    }
    this.otpError = '';
    if (value && index < 3) {
      const inputs = this.otpInputs.toArray();
      inputs[index + 1].nativeElement.focus();
    }
  }

  onOtpKeyDown(event: KeyboardEvent, index: number) {
    if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
      const inputs = this.otpInputs.toArray();
      inputs[index - 1].nativeElement.focus();
    }
  }

  onOtpPaste(event: ClipboardEvent) {
    event.preventDefault();
    const paste = event.clipboardData?.getData('text') || '';
    const digits = paste.replace(/\D/g, '').substring(0, 4);
    for (let i = 0; i < 4; i++) {
      this.otpDigits[i] = digits[i] || '';
    }
    if (digits.length > 0) {
      const inputs = this.otpInputs.toArray();
      const focusIndex = Math.min(digits.length, 3);
      inputs[focusIndex].nativeElement.focus();
    }
    this.otpError = '';
  }

  get otpCode(): string {
    return this.otpDigits.join('');
  }

  submitOtp() {
    if (this.otpCode.length < 4 || this.otpRequestInProgress) return;

    if (this.approveInvoiceId) {
      this.submitInvoiceApproval();
      return;
    }

    if (!this.selectedApproveVendorId || !this.selectedApprovePeriod) return;

    this.otpRequestInProgress = true;
    this.installationService
      .approveDtMeterInstallationMeter({
        organizationId: this.selectedApproveVendorId,
        year: this.selectedApprovePeriod.year,
        month: this.selectedApprovePeriod.month,
        code: this.otpCode,
      })
      .subscribe({
        next: (response) => {
          this.otpRequestInProgress = false;
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.toastr.success('Meter installation approved');
            this.closeOtpModal();
            this.getInstallationStats();
            this.loadInvoiceStats();
            this.reloadTable(1);
          } else {
            this.handleApprovalError(responseData?.status, responseData?.message || '');
          }
        },
        error: (_) => {
          this.otpRequestInProgress = false;
          this.otpError = 'An error occurred. Please try again.';
        },
      });
  }

  private requestInvoiceApprovalOtp(openModal: boolean) {
    if (this.otpRequestInProgress || !this.approveInvoiceId) return;

    this.otpRequestInProgress = true;
    this.installationService
      .requestDtMeterInvoiceApprovalOtp({ invoiceId: this.approveInvoiceId })
      .subscribe({
        next: (response) => {
          this.otpRequestInProgress = false;
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.otpMaskedEmail = responseData.data?.maskedEmail ?? '';
            this.otpDigits = ['', '', '', ''];
            this.otpError = '';
            this.otpExpired = false;
            this.startOtpResendTimer();
            if (openModal) this.openOtpModal('approveDtMeterInstallationInvoice');
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.otpRequestInProgress = false;
          this.toastr.error('Error occured');
        },
      });
  }

  private submitInvoiceApproval() {
    this.otpRequestInProgress = true;
    this.installationService
      .approveDtMeterInstallationInvoice({ invoiceId: this.approveInvoiceId, code: this.otpCode })
      .subscribe({
        next: (response) => {
          this.otpRequestInProgress = false;
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.toastr.success(responseData?.message);
            this.closeOtpModal();
            this.reloadInvoiceTable();
            this.loadInvoiceStats();
          } else {
            this.handleApprovalError(responseData?.status, responseData?.message || '');
          }
        },
        error: (_) => {
          this.otpRequestInProgress = false;
          this.otpError = 'An error occurred. Please try again.';
        },
      });
  }

  private handleApprovalError(status: any, message: string) {
    if (status === 401 || status === 'Unauthorized') {
      this.otpError = message;
      this.otpExpired = message.toLowerCase().includes('expired');
      this.otpDigits = ['', '', '', ''];
      return;
    }

    this.toastr.error(message);
    this.closeOtpModal();
  }

  closeOtpModal() {
    this.stopOtpResendTimer();
    this.approveInvoiceId = 0;
    this.otpDigits = ['', '', '', ''];
    this.otpError = '';
    this.otpExpired = false;
    this.otpModalInstance?.hide();
  }

  private requestApprovalOtp(openModal: boolean) {
    if (this.otpRequestInProgress) return;
    if (!this.selectedApproveVendorId || !this.selectedApprovePeriod) return;

    this.otpRequestInProgress = true;
    this.installationService
      .requestDtMeterApprovalOtp({
        organizationId: this.selectedApproveVendorId,
        year: this.selectedApprovePeriod.year,
        month: this.selectedApprovePeriod.month,
        action:
          this.approveMode === ApproveMode.Meter
            ? OtpAction.ApproveDtMeterInstallationMeter
            : OtpAction.ApproveDtMeterInstallationInvoice,
      })
      .subscribe({
        next: (response) => {
          this.otpRequestInProgress = false;
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.otpMaskedEmail = responseData.data?.maskedEmail ?? '';
            this.otpDigits = ['', '', '', ''];
            this.otpError = '';
            this.otpExpired = false;
            this.startOtpResendTimer();
            if (openModal) this.openOtpModal();
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.otpRequestInProgress = false;
          this.toastr.error('Error occured');
        },
      });
  }

  private openOtpModal(sourceModalId: string = 'approveDtMeterInstallation') {
    const otpModalElement = document.getElementById('otpVerification');
    if (!otpModalElement) return;

    const showOtpModal = () => {
      this.otpModalInstance = bootstrap.Modal.getInstance(otpModalElement) ?? new bootstrap.Modal(otpModalElement);
      this.otpModalInstance.show();
    };

    const approveModalElement = document.getElementById(sourceModalId);
    const approveModal = approveModalElement ? bootstrap.Modal.getInstance(approveModalElement) : null;
    if (approveModal) {
      approveModalElement!.addEventListener('hidden.bs.modal', showOtpModal, { once: true });
      approveModal.hide();
    } else {
      showOtpModal();
    }
  }

  private startOtpResendTimer() {
    this.stopOtpResendTimer();
    this.otpResendSeconds = 60;
    this.otpResendTimer = setInterval(() => {
      this.otpResendSeconds--;
      if (this.otpResendSeconds <= 0) this.stopOtpResendTimer();
    }, 1000);
  }

  private stopOtpResendTimer() {
    if (this.otpResendTimer) {
      clearInterval(this.otpResendTimer);
      this.otpResendTimer = undefined;
    }
    this.otpResendSeconds = 0;
  }

  private getDtInstallationPeriods() {
    this.installationService.getDtInstallationPeriods().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.approvePeriods = responseData.data ?? [];
          this.approveVendors = [
            ...new Map(this.approvePeriods.map((x) => [x.vendorId, { id: x.vendorId, name: x.vendorName }])).values(),
          ];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  changeTab(page: number) {
    this.clearInvoiceTab();
    this.currentTab = page;
    if(this.currentTab == 4) {
      this.currentTabName = 'Assigned';
    } else if(this.currentTab == 3) {
      this.currentTabName = 'Rejected';
    } else if(this.currentTab == 2) {
      this.currentTabName = 'Approved';
    } else if(this.currentTab == 1) {
      this.currentTabName = 'Submitted';
    } else if(this.currentTab == 8) {
      this.currentTabName = 'AwaitingApproval';
    }

    this.searchText = '';
    this.resetFilter(1, false);
    this.pageChange(1);
  }
  search() {
        this.searchFilterApplied = this.searchText ? true : false;
    this.reloadTable(1);
  }
    selectSearchType(searchType: any) {
    if (this.searchText && this.searchFilterApplied) {
      this.searchText = '';
      this.search();
    }
    this.selectedSearchType = searchType.name;
    this.selectedSearchTypeDisplay = searchType.translation;
    this.showSelectSearchType = false;
  }
  isAllCheckBoxChecked() {
    return false;
  }
  checkAllCheckBox(event: any) {}
  pageChange(value: any) {
    this.currentPage = value;
    this.reloadTable();
  }
  private getData(): void {
    this.reloadTable();
  }
  reloadTable(page: any = null) {
    if (page) this.currentPage = page;
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
        count: this.count
      },
      filterParams: this.getFilterObject(),
    };

    this.analyticsService.logCustomEvent('INSTALLATIONS: Filter list', {
      page: obj.pageInfo.page,
      search: obj.filterParams.search,
      date_from: obj.filterParams.dateFrom,
      date_to: obj.filterParams.dateTo,
      status: obj.filterParams.status,
      customer_type: obj.filterParams.customerType,
      areas: obj.filterParams.selectedAreas,
      regions: obj.filterParams.selectedRegions,
      tariff: obj.filterParams.tariffId,
      customer_phase: obj.filterParams.customerPhase,
      meter_status: obj.filterParams.meterStatus,
      sort_by: obj.filterParams.sortBy,
      tab: this.currentTabName
    });
    
    this.getAll(obj);
  }
  openCreateModal() {
    this.detailsShowed = !this.detailsShowed;
  }
  private getAll(obj: any) {
    this.installations = [];
    this.count = 0;
    const request = this.selectedMeterTab === MeterTypeTab.DtMeter
      ? this.installationService.getAllDtInstallations(obj)
      : this.installationService.getAll(obj);
    request.subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.installations = responseData.data.data;
          this.count = responseData.data.count;
          this.createFilterCards();
          this.removeFilterStorage();
          if (responseData.message != '') {
            this.toastr.warning(responseData.message);
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }
  private subscribeToClickEvent() {
    this.clickObservable
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((e: any) => {});
  }
  openAcknowledgeModal(invoice: DtMeterInstallationInvoiceDto) {
    this.acknowledgeInvoiceId = invoice.id;
  }
  acknowledgeRepayment() {
    this.installationService.acknowledgeInvoiceRepayment(this.acknowledgeInvoiceId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success(responseData?.message);
          this.closeAcknowledgeModal?.nativeElement?.click();
          this.reloadInvoiceTable();
          this.loadInvoiceStats();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }
  sortBy(option: SortByOptions) {
    this.sortByValue = option;
    this.sortByName = this.mapSortBy[option];
    this.reloadTable();
  }
  datesValid() {
    if (this.dateFrom && this.dateTo) {
        const valid: boolean = new Date(this.dateFrom).getTime() < new Date(`${this.dateTo.toString()}T23:59:59`).getTime();
        return valid;
    }
    return false;
  }
  private getInstallationStats() {
    const meterInventoryType = this.selectedMeterTab === MeterTypeTab.DtMeter ? MeterInventoryType.Asset : MeterInventoryType.Customer;
    this.installationService.getInstallationStats(meterInventoryType).subscribe({
      next: (response) => {
        const data = response.body;
        if (data?.status === 200 || data?.status === 'OK') {
          data.data.forEach((element) => {
            if (element.key == 'Rejected') {
              this.countRejected = element.value;
              data.data = data.data.filter((item) => item != element);
            } else if (element.key == 'Submited') {
              this.countSubmited = element.value;
              data.data = data.data.filter((item) => item != element);
            } else if (element.key == 'Resubmitted') {
              this.countResubmitted = element.value;
              data.data = data.data.filter((item) => item != element);
            } else if (element.key == 'Approved') {
              this.countApproved = element.value;
              data.data = data.data.filter((item) => item != element);
            } else if (element.key == 'Assigned') {
              this.countAssigned = element.value;
              data.data = data.data.filter((item) => item != element);
            } else if (element.key == 'AwaitingApproval') {
              this.countAwaitingApproval = element.value;
              data.data = data.data.filter((item) => item != element);
            }
          });
          this.stats = data.data;
        } else {
          this.toastr.error(data?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getRegions() {
    this.regionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.regions = responseData.data;
          this.setCheckedRegions();
          this.createFilterCards();
          this.removeFilterStorage(); 
          // this.getAreas();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getAreas() {
    this.areaService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allAreas = responseData.data;
          this.setCheckedAreas();
          this.createFilterCards();
          this.removeFilterStorage();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getGeographicalRegions() {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.geographicalRegions = responseData.data;
          this.setCheckedGeographicalRegions();
          this.createFilterCards();
          this.removeFilterStorage();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getSubGeographicalRegions() {
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allSubGeographicalRegions = responseData.data;
          this.setCheckedSubGeographicalRegions();
          this.createFilterCards();
          this.removeFilterStorage();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  getDetailsRouterLink(installation: InstallationTableData) {
    if (this.selectedMeterTab === MeterTypeTab.DtMeter) {
      if (installation.installationCategory === InstallationCategory[InstallationCategory.Customer]) return ['awaiting-approval', installation.id];
      return this.currentTab === 8 ? ['dt', 'awaiting-approval', installation.id] : ['dt', 'details', installation.id];
    }
    return ['details', installation.id];
  }

  setFilterStorage() {
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
        count: this.count
      },
      filterParams: this.getFilterObject(),
    };

    // Remove 'T23:59:59' from the dateTo to avoid errors
    if (obj.filterParams.dateTo) {
        obj.filterParams.dateTo = obj.filterParams.dateTo.replace('T23:59:59', '');
    }

    localStorage.setItem(
      'filter',
      JSON.stringify({ type: 'Installation', filter: obj })
    );
  }
  getTariffs() {
    this.tariffService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.tariffs = responseData.data;
          this.createFilterCards();
          this.removeFilterStorage();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  selectRegion(e: any) {
    //list of areas for selected regions
    this.areas= this.allAreas.filter(area => this.regions.some(region => region.id == area.regionId && region.checked));
    this.allAreas.forEach(area => { 
      if (!this.areas.some(a => a.id === area.id)) {
        area.checked = false; //uncheck areas for unchecked regions
      }
    });

    this.createFilterCards();
  }

  selectArea(e: any) {
    this.createFilterCards();
  }
  selectGeographicalRegion(e: any) {
    this.subGeographicalRegions = this.allSubGeographicalRegions.filter(sub => this.geographicalRegions.some(region => region.id == sub.geographicalRegion.id && region.checked));
    this.allSubGeographicalRegions.forEach(sub => {
      if (!this.subGeographicalRegions.some(s => s.id === sub.id)) {
        sub.checked = false; 
      }
    });

    this.createFilterCards();
  }
  selectTariff(e: any) {
    this.tariff = +e.target.value;
    this.createFilterCards();
    this.reloadTable(1);
  }
  selectCustomerType(e: any) {
    this.customerType = +e.target.value;
    this.createFilterCards();
    this.reloadTable(1);
  }
  selectCustomerPhase(e: any) {
    this.customerPhase = +e.target.value;
    this.createFilterCards();
    this.reloadTable(1);
  }
  selectMeterStatus(e: any) {
    this.meterStatus = +e.target.value;
    this.createFilterCards();
    this.reloadTable(1);
  }
  selectDtType(e: any) {
    this.dtType = +e.target.value;
    this.createFilterCards();
    this.reloadTable(1);
  }
  selectInstallationCategory(e: any) {
    this.installationCategory = +e.target.value;
    this.createFilterCards();
    this.reloadTable(1);
  }
  selectDtMeterStatus(e: any) {
    this.dtMeterStatus = +e.target.value;
    this.createFilterCards();
    this.reloadTable(1);
  }
  selectMapVendor(e: any) {
    this.selectedOrganizationId = +e.target.value;
    this.createFilterCards();
    this.reloadTable(1);
  }
  selectSubmissionStatus(e: any) {
    this.submissionStatus = +e.target.value;
    this.createFilterCards();
    this.reloadTable(1);
  }
  onPeriodApply(e: { year: number; months: number[] }) {
    if (e.months.length > 0) {
      this.periodYear = e.year;
      this.periodMonths = e.months;
    } else {
      this.periodYear = 0;
      this.periodMonths = [];
    }
    this.createFilterCards();
    this.reloadTable(1);
  }
  selectReopenStatus(e: any) {
    this.reopenStatus = +e.target.value;
    this.createFilterCards();
    this.reloadTable(1);
  }
  private getOrganizations() {
    this.organizationService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body ?? response;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.organizations = responseData.data;
          this.createInvoiceFilterCards();
        }
      },
      error: (_) => {}
    });
  }
  getInstallationCategoryTranslation = getInstallationCategoryTranslation;
  removeFilter(item: ChecklistItem) {
    if (item.property == this.buName) {
      this.regions.forEach((region) => {
        if (region.name === item.selectedValue) {
          region.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == this.utName) {
      this.areas.forEach((area) => {
        if (area.name === item.selectedValue) {
          area.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == 'Geographical Region') {
      this.geographicalRegions.forEach((region) => {
        if (region.name === item.selectedValue) {
          region.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == 'Sub Geographical Region') {
      this.subGeographicalRegions.forEach((sub) => {
        if (sub.name === item.selectedValue) {
          sub.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == 'Tariff') {
      this.tariff = 0;
    } else if (item.property == 'Customer Type') {
      this.customerType = 0;
    } else if (item.property == 'Customer Phase') {
      this.customerPhase = -1;
    } else if (item.property == 'Meter Status') {
      this.meterStatus = 0;
    } else if (item.property == 'MAP Vendor') {
      this.selectedOrganizationId = 0;
    } else if (item.property == 'Submission Status') {
      this.submissionStatus = 0;
    } else if (item.property == 'DT Type') {
      this.dtType = 0;
    } else if (item.property == 'Installation Category') {
      this.installationCategory = 0;
    } else if (item.property == 'DT Meter Status') {
      this.dtMeterStatus = 0;
    } else if (item.property == 'Period') {
      this.periodMonths = [];
      this.periodYear = 0;
    } else if (item.property == 'Vendor') {
      this.selectedOrganizationId = 0;
    } else if (item.property == 'Search') {
      this.searchText = '';
      this.searchFilterApplied = false;
    } else if (item.property == 'Request Instance') {
      this.reopenStatus = 0;
    }

    this.createFilterCards();
    this.reloadTable(1);
  }

  resetFilter(e: any, reload: boolean = true) {
    this.selectedFilters = [];

    this.regions.forEach((region) => {
      region.checked = false;
    });

    this.areas.forEach((area) => {
      area.checked = false;
    });
    this.areas = [];
    this.selectedAreas = [];
    this.selectedRegions = [];

    this.geographicalRegions.forEach((region) => {
      region.checked = false;
    });

    this.subGeographicalRegions.forEach((sub) => {
      sub.checked = false;
    });
    this.subGeographicalRegions = [];
    this.selectedSubGeographicalRegions = [];

    this.tariff = 0;
    this.customerPhase = -1;
    this.customerType = 0;
    this.meterStatus = 0;
    this.dtType = 0;
    this.installationCategory = 0;
    this.dtMeterStatus = 0;
    this.clicked = !this.clicked;
    this.searchText = '';
    this.selectedOrganizationId = 0;
    this.submissionStatus = 0;
    this.periodMonths = [];
    this.periodYear = 0;
    this.reopenStatus = 0;
    if (reload) this.reloadTable(1);
  }

  createFilterCards() {
    this.selectedFilters = [];

    let selectedAreas = this.areas.filter((x) => x.checked);
    this.selectedAreas = this.areas.filter((x) => x.checked).map((x) => x.id);
    this.selectedRegions = this.regions.filter((x) => x.checked).map((x) => x.id);

    let selectedSubGeographicalRegions = this.subGeographicalRegions.filter((x) => x.checked);
    this.selectedSubGeographicalRegions = selectedSubGeographicalRegions.map((x) => x.id as number);

    //areas
    for (var i = 0; i < selectedAreas.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(this.utName, selectedAreas[i].name, 'COMMON.UT.SINGLE')
      );
    }

    for (var i = 0; i < selectedSubGeographicalRegions.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem('Sub Geographical Region', selectedSubGeographicalRegions[i].name, 'COMMON.SUB_GEOGRAPHICAL_REGION.SINGLE')
      );
    }

    //tariff
    if (this.tariff != 0) {
      let tariffName = this.tariffs.filter((x) => x.id == this.tariff)[0].name;
      this.selectedFilters.push(new ChecklistItem('Tariff', tariffName, 'COMMON.TARIFF.SINGLE'));
    }

    if (this.customerType != 0) {
      let type = this.customerTypeOptions.filter(
        (x) => x.value == this.customerType
      )[0];
      this.selectedFilters.push(new ChecklistItem('Customer Type', type.name, 'COMMON.MBC_DETAILS.CUSTOMER_TYPE', type.translation));
    }
    if (this.customerPhase != -1) {
      let phase = this.customerPhaseOptions.filter(
        (x) => x.value == this.customerPhase
      )[0];
      this.selectedFilters.push(new ChecklistItem('Customer Phase', phase.name, 'COMMON.CUSTOMER.CUSTOMER_PHASE', phase.translation));
    }
    if (this.meterStatus != 0) {
      let status = this.meterStatusOptions.filter(
        (x) => x.value == this.meterStatus
      )[0];
      this.selectedFilters.push(new ChecklistItem('Meter Status', status.name, 'COMMON.MBC_DETAILS.METER_STATUS', status.translation));
    }
    if (this.selectedOrganizationId != 0) {
      let org = this.organizations.find((x) => x.id == this.selectedOrganizationId);
      if (org) {
        if (this.selectedMeterTab === MeterTypeTab.DtMeter) {
          this.selectedFilters.push(new ChecklistItem('Vendor', org.name, 'INSTALLATIONS.INVOICE.VENDOR'));
        } else {
          this.selectedFilters.push(new ChecklistItem('MAP Vendor', org.name, 'SURVEYS.MAP_VENDOR'));
        }
      }
    }
    if (this.periodMonths.length > 0 && this.periodYear != 0) {
      const shortNames = this.periodMonths
        .slice()
        .sort((a, b) => a - b)
        .map((m) => new Date(2000, m - 1, 1).toLocaleString('en', { month: 'short' }));
      this.selectedFilters.push(new ChecklistItem('Period', `${shortNames.join(', ')} ${this.periodYear}`, 'INSTALLATIONS.INVOICE.PERIOD'));
    }
    if (this.searchText && this.searchFilterApplied) {
      this.selectedFilters.push(new ChecklistItem('Search', this.searchText, this.selectedSearchTypeDisplay));
    }
    if (this.submissionStatus != 0) {
      let status = this.submissionStatusOptions.filter(
        (x) => x.value == this.submissionStatus
      )[0];
      this.selectedFilters.push(new ChecklistItem('Submission Status', status.name, 'COMMON.ASSET_STATUS.STATUS', status.translation));
    }
    if (this.dtType != 0) {
      let type = this.dtTypeOptions.filter(
        (x) => x.value == this.dtType
      )[0];
      this.selectedFilters.push(new ChecklistItem('DT Type', type.name, 'TRANSFORMERS.DT_TYPE', type.translation));
    }
    if (this.installationCategory != 0) {
      let category = this.installationCategoryOptions.find((x) => x.value == this.installationCategory);
      if (category) {
        this.selectedFilters.push(new ChecklistItem('Installation Category', category.name, 'INSTALLATIONS.INSTALLATION_CATEGORY', category.translation));
      }
    }
    if (this.dtMeterStatus != 0) {
      let status = this.meterStatusOptions.filter(
        (x) => x.value == this.dtMeterStatus
      )[0];
      this.selectedFilters.push(new ChecklistItem('DT Meter Status', status.name, 'COMMON.MBC_DETAILS.METER_STATUS', status.translation));
    }
    if (this.reopenStatus != 0) {
      let option = this.reopenStatusOptions.find((x) => x.value == this.reopenStatus);
      if (option) {
        this.selectedFilters.push(new ChecklistItem('Request Instance', option.name, 'SURVEYS.REQUEST_INSTANCE', option.translation));
      }
    }
  }

  setCheckedAreas() {
    var filter = localStorage.getItem('filter');
    if (!filter) return;
    var filterObject = JSON.parse(filter);
    if (filterObject.type != 'Installation') return;
    if (filterObject.filter.filterParams.selectedAreas) {
      this.selectedAreas = filterObject.filter.filterParams.selectedAreas;
      this.areas.forEach((element) => {
        if (this.selectedAreas.includes(element.id)) element.checked = true;
        else element.checked = false;
      });
    }
  }
  setCheckedRegions() {
    var filter = localStorage.getItem('filter');
    if (!filter) return;
    var filterObject = JSON.parse(filter);
    if (filterObject.type != 'Installation') return;
    if (filterObject.filter.filterParams.selectedRegions) {
      this.selectedRegions = filterObject.filter.filterParams.selectedRegions;
      this.regions.forEach((element) => {
        if (this.selectedRegions.includes(element.id)) element.checked = true;
        else element.checked = false;
      });
    }
  }
  setCheckedSubGeographicalRegions() {
    var filter = localStorage.getItem('filter');
    if (!filter) return;
    var filterObject = JSON.parse(filter);
    if (filterObject.type != 'Installation') return;
    if (filterObject.filter.filterParams.selectedSubgeographicalRegions) {
      this.selectedSubGeographicalRegions = filterObject.filter.filterParams.selectedSubgeographicalRegions;
      this.subGeographicalRegions.forEach((element) => {
        if (this.selectedSubGeographicalRegions.includes(element.id as number)) element.checked = true;
        else element.checked = false;
      });
    }
  }
  setCheckedGeographicalRegions() {
    var filter = localStorage.getItem('filter');
    if (!filter) return;
    var filterObject = JSON.parse(filter);
    if (filterObject.type != 'Installation') return;
    if (filterObject.filter.filterParams.selectedGeographicalRegions) {
      let selectedGeographicalRegions = filterObject.filter.filterParams.selectedGeographicalRegions;
      this.geographicalRegions.forEach((element) => {
        if (selectedGeographicalRegions.includes(element.id)) element.checked = true;
        else element.checked = false;
      });
    }
  }

  setFilters() {
    var filter = localStorage.getItem('filter');
    if (!filter) return;
    var filterObject = JSON.parse(filter);
    if (filterObject.type != 'Installation') return;
    this.currentPage = filterObject.filter.pageInfo.page;
    this.pageSize = filterObject.filter.pageInfo.pageSize;
    this.count = filterObject.filter.pageInfo.count;
    this.sortByValue = filterObject.filter.filterParams.sortBy;
    this.searchText = filterObject.filter.filterParams.search;
    this.dateFrom = filterObject.filter.filterParams.dateFrom;
    this.dateTo = filterObject.filter.filterParams.dateTo;
    this.tariff = filterObject.filter.filterParams.tariffId
      ? filterObject.filter.filterParams.tariffId
      : 0;
    this.currentTab = filterObject.filter.filterParams.status;
    this.selectedAreas = filterObject.filter.filterParams.selectedAreas
      ? filterObject.filter.filterParams.selectedAreas
      : [];
    this.meterStatus = filterObject.filter.filterParams.meterStatus;
    this.customerPhase = filterObject.filter.filterParams.customerPhase;
    this.customerType = filterObject.filter.filterParams.customerType;
    this.selectedRegions = filterObject.filter.filterParams.selectedRegions
      ? filterObject.filter.filterParams.selectedRegions
      : [];
    this.selectedSubGeographicalRegions = filterObject.filter.filterParams.selectedSubgeographicalRegions
      ? filterObject.filter.filterParams.selectedSubgeographicalRegions
      : [];
    this.selectedOrganizationId = filterObject.filter.filterParams.organizationId
      ? filterObject.filter.filterParams.organizationId
      : 0;
    this.submissionStatus = filterObject.filter.filterParams.submissionStatus
      ? filterObject.filter.filterParams.submissionStatus
      : 0;
    this.reopenStatus = filterObject.filter.filterParams.reopenStatus ?? 0;
  }
  removeFilterStorage()
  {
    if(this.tariffs.length>0 &&
      ((this.areas.length>0 && this.regions.length>0) ||
        (this.subGeographicalRegions.length>0 && this.geographicalRegions.length>0)))
      localStorage.removeItem('filter');
  }
}
